module.exports = __webpack_public_path__ + "static/media/oscar.73754671.svg";